import * as React from "react"
import Box from "@mui/material/Box"
import { CircularProgressbar, buildStyles } from "react-circular-progressbar"
import "react-circular-progressbar/dist/styles.css"

function CircularProgressWithLabel(props: any) {
  const textColor = props.isActive ? (props.isFull ? "green" : "red") : "gray"
  const pathColor = props.isActive
    ? props.isFull
      ? "#27af8d"
      : "#E21824"
    : "#7D7D7D"
  const trailColor = props.isActive ? "#E1E1E1" : "#E1E1E1"

  return (
    <Box
      sx={{
        position: "relative",
        display: "inline-flex",
        height: 72,
        width: 72,
      }}
    >
      <CircularProgressbar
        value={props.value}
        text={`${props.value}%`}
        styles={buildStyles({
          textColor,
          pathColor,
          trailColor,
        })}
      />
    </Box>
  )
}

export default function CircularWithValueLabel({
  progress,
  isActive,
  isFull,
}: {
  progress: number
  isActive: boolean
  isFull: boolean
}) {
  return (
    <CircularProgressWithLabel
      isActive={isActive}
      isFull={isFull}
      value={progress}
    />
  )
}
